<template>
  <header class="layout-header section bg-background">
    <div class="container">
      <div class="layout-header-inner">
        <div class="layout-header-content">
          <Logo
            v-bind="logo"
            class="relative z-100 mb-4 belowDesktop:inline-block belowDesktop:pt-4"
          />
          <StorageMenuOldNavigationNavbar
            v-if="menuMobileOpen || !isUntilDesktop"
            :links="mapped"
            @close-mobile-menu="onBurgerToggle"
          />
        </div>
      </div>
    </div>
    <StorageMenuOldNavigationNavbarBurger
      v-show="isUntilDesktop"
      :is-open="menuMobileOpen"
      @toggle="onBurgerToggle"
    />
  </header>
</template>

<script lang="ts" setup>
import { useSubtreeIndex } from '../../../../composables/useOldMenu'
import type { MenuLinkTreeFirstFragment } from '#graphql-operations'

const { logo } = useLogo()
const { isUntilDesktop } = useViewport()

const props = defineProps<{
  links: MenuLinkTreeFirstFragment[]
}>()

const menuMobileOpen = ref(false)

const subtreeIndex = useSubtreeIndex()

const mapped = useOldMenu(props.links)

function onBurgerToggle() {
  menuMobileOpen.value = !menuMobileOpen.value
  if (isUntilDesktop.value && !menuMobileOpen.value) {
    subtreeIndex.value = -1
  }
}
</script>

<style>
@reference '~/assets/css/tailwind.css';
.layout-header {
  @apply py-0;
  @apply tablet:border-b tablet:border-solid tablet:border-border;
  @apply desktop:sticky desktop:left-0 desktop:w-full desktop:border-b-0;
  @apply widescreen:text-size-5;
  font-size: 1rem;

  @variant desktop {
    top: -1px;
    z-index: 1000;
    body.has-hero-image & {
      &:after {
        transform: scaleY(0);
      }
    }
  }

  &:after {
    @apply desktop:absolute desktop:top-0 desktop:left-0 desktop:h-full desktop:w-full desktop:bg-background;
    @variant desktop {
      content: '';
      transition: 0.5s;
      transform-origin: top;
    }
  }

  .container {
    @apply font-bold text-black;
  }
}

.layout-header-inner {
  @apply desktop:relative desktop:z-100 desktop:my-0 desktop:py-0;
  @apply widescreen:my-0 widescreen:py-0;

  &:not(.is-active) {
    body.has-hero-image & {
      .logo a:last-child {
        @apply desktop:text-white;
      }
    }
  }

  body.has-hero-image & {
    .logo a:last-child {
      @apply belowDesktop:text-white;
    }
  }

  .logo {
    @apply belowDesktop:relative belowDesktop:inline-block belowDesktop:text-size-6;
    line-height: 0.8;
    margin-bottom: 1rem;
    align-self: auto;

    @variant belowDesktop {
      z-index: 50;
      padding-top: 1rem;
      margin-bottom: 1rem;
    }
  }
}
.layout-header-content {
  @apply desktop:flex desktop:items-end desktop:justify-between desktop:border-b desktop:border-solid desktop:border-border;
  @variant desktop {
    height: 4rem;
    height: 5rem;

    .logo a:last-child,
    .navbar-first-link {
      transition: 0.5s;
    }
  }
}

.layout-header-overlay,
.navbar-first-overlay {
  @apply fixed top-0 left-0 h-full w-full;
  background: rgba(0, 0, 0, 0.8);
  z-index: 99;
}

.layout-header-overlay {
  z-index: 99;
}
.navbar-first-overlay {
  z-index: 100;
}
</style>
